type CookieOptions = {
  expires?: Date | string;
  secure?: boolean;
  'max-age'?: number;
  path?: string;
  domain?: string;
};

export const getCookie = (name: string): string | undefined => {
  const matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
  );

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  const defaultOptions: CookieOptions = {
    path: '/',
    ...options,
  };

  if (defaultOptions.expires instanceof Date) {
    defaultOptions.expires = defaultOptions.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (const optionKey in defaultOptions) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions, optionKey)) {
      updatedCookie += '; ' + optionKey;
      const optionValue = defaultOptions[optionKey as keyof CookieOptions];
      if (optionValue !== true && optionValue !== undefined) {
        updatedCookie += '=' + optionValue;
      }
    }
  }

  document.cookie = updatedCookie;
};

export const deleteCookie = (name: string, options: Omit<CookieOptions, 'expires' | 'max-age'> = {}): void => {
  setCookie(name, '', {
    ...options,
    'max-age': -1,
  });
};
